<template>
  <div>
    <cancel-heading is-centered>Discount Processed</cancel-heading>
    <cancel-content is-centered>Congratulations, you're saving money!</cancel-content>
    <cancel-content is-centered>As promised, your next 3 monthly subscription charges will be 66% less!</cancel-content>
    <cancel-icon/>
  </div>
</template>

<script>
import CancelContent from "./components/CancelContent.vue";
import CancelIcon from "./components/CancelIcon.vue";
import CancelHeading from "./components/CancelHeading.vue";

export default {
  name: "OfferDiscountConfirmation",
  components: {CancelHeading, CancelIcon, CancelContent}
}
</script>
